import { createSlice } from "@reduxjs/toolkit";
import homeInitialState from "@/components/PageHome/redux/initialState";
import HomeReducer from "@/components/PageHome/redux/reducers";

const homeSlice = createSlice({
  name: "home",
  initialState: homeInitialState,
  reducers: HomeReducer,
});

export const { setCurrentFlow, setFlowData, clearFlowData, setLoading, setError, setHomeData } = homeSlice.actions;

export default homeSlice.reducer;
